// =============================================================================
// features/sales/campaigns/wizard/steps/Step4Distribution.tsx — Etapa 4:
// estratégia de distribuição (F35-S08, doc 26 §6.6/§8). O campo persistido é
// `assignmentStrategy` (`Campaign`, packages/shared-schemas) — não existe
// hoje um campo de "pool de vendedores" na campanha (formado dinamicamente
// pelos membros já atribuídos, F35-S06); por isso a etapa explica em texto
// como cada estratégia decide quem atende, em vez de fingir um seletor de
// pessoas que a API não aceita.
// =============================================================================

import * as React from 'react';

import { cn } from '../../../../../lib/cn';
import { WizardStepShell } from '../components/WizardStepShell';
import { ASSIGNMENT_STRATEGY_OPTIONS } from '../labels';
import type { DistributionValues } from '../types';

export interface Step4DistributionProps {
  values: DistributionValues;
  onChange: (values: DistributionValues) => void;
  onBack: () => void;
  onContinue: () => void;
  isPending: boolean;
  errorMessage: string | null;
}

export function Step4Distribution({
  values,
  onChange,
  onBack,
  onContinue,
  isPending,
  errorMessage,
}: Step4DistributionProps): React.JSX.Element {
  return (
    <WizardStepShell
      title="Distribuição da carteira"
      description="Como os clientes desta campanha chegam até os vendedores."
      onBack={onBack}
      onContinue={onContinue}
      isPending={isPending}
      errorMessage={errorMessage}
    >
      <div
        role="radiogroup"
        aria-label="Estratégia de distribuição"
        className="flex flex-col gap-3"
      >
        {ASSIGNMENT_STRATEGY_OPTIONS.map((opt) => {
          const checked = values.assignmentStrategy === opt.value;
          return (
            <label
              key={opt.value}
              className={cn(
                'flex items-start gap-3 rounded-sm border p-4 cursor-pointer transition-colors duration-fast',
                checked
                  ? 'border-azul bg-[rgba(27,58,140,0.06)]'
                  : 'border-border-strong hover:bg-surface-hover',
              )}
              style={{ boxShadow: checked ? 'var(--elev-1)' : undefined }}
            >
              <input
                type="radio"
                name="assignment-strategy"
                checked={checked}
                onChange={() => onChange({ assignmentStrategy: opt.value })}
                className="mt-1 w-4 h-4 accent-azul"
              />
              <div>
                <p className="font-sans text-sm font-semibold text-ink">{opt.label}</p>
                <p className="font-sans text-xs text-ink-3 mt-0.5">{opt.hint}</p>
              </div>
            </label>
          );
        })}
      </div>
    </WizardStepShell>
  );
}
